import { render, staticRenderFns } from "./DividendsChart.vue?vue&type=template&id=7b1f4979&"
import script from "./DividendsChart.vue?vue&type=script&lang=js&"
export * from "./DividendsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports